import { render, staticRenderFns } from "./SetUp.vue?vue&type=template&id=5aae6f00&"
import script from "./SetUp.vue?vue&type=script&lang=ts&"
export * from "./SetUp.vue?vue&type=script&lang=ts&"
import style0 from "./SetUp.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.4.2@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "SetUp.vue"
export default component.exports